function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.125 29.2727L17.5 35L21.875 29.2727H30.0877C32.8007 29.2727 35 26.9934 35 24.1818V5.09091C35 2.27928 32.8007 0 30.0877 0H4.91228C2.1993 0 0 2.27928 0 5.09091V24.1818C0 26.9934 2.1993 29.2727 4.91228 29.2727H13.125ZM17.5 31.9243L20.9838 27.3636H30.0877C31.7833 27.3636 33.1579 25.9391 33.1579 24.1818V5.09091C33.1579 3.33364 31.7833 1.90909 30.0877 1.90909H4.91228C3.21667 1.90909 1.84211 3.33364 1.84211 5.09091V24.1818C1.84211 25.9391 3.21667 27.3636 4.91228 27.3636H14.0162L17.5 31.9243Z",
  fill: "#BDBDBD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.75439,
  y: 7.63635,
  width: 20.8772,
  height: 3.18182,
  rx: 1.59091,
  fill: "#BDBDBD"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.75439,
  y: 12.7273,
  width: 20.8772,
  height: 3.18182,
  rx: 1.59091,
  fill: "#BDBDBD"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 6.75439,
  y: 17.8182,
  width: 12.8947,
  height: 3.18182,
  rx: 1.59091,
  fill: "#BDBDBD"
});

function SvgCommentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.3158ad02.svg";
export { ForwardRef as ReactComponent };